import type { OrganizationRepository } from '@/core/organization'
import type { UseCase } from '@/core/shared'

export const getAll: UseCase<OrganizationRepository, 'getAll'> = repository => {
  return async (params) => {
    return await repository.getAll(params)
  }
}
